import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import appconfig from "./../appconfig.json";
import axios from 'axios';
// import setLanguage  from 'translation';

class AfterWorkingHours extends Component {
    /*openCallMe = () =>{
        var url = "http://www.google.com/";
        window.location.href = url;
    }
    
    openContactUs = () =>{
        var url = "http://www.google.com/";
        window.location.href = url;
    }*/

    isPublic = () => {
        const queryParams = new URLSearchParams(window.location.search)
        let fullName = queryParams.get("fullname");
        if (fullName != null && fullName != "" && fullName != undefined) {
            return false;
        } else {
            return true;
        }
    }

    componentDidMount(): void {
    
        // let language = localStorage.getItem("lang")
        // // console.log("kiro",language)
        //  setLanguage(language);
         this.loadWorkingHoursMessage();
    }

    // loadWorkingHoursMessage = () =>{
    //     let admin_message = document.getElementById("admin_message") as HTMLElement;
    //     let default_message = document.getElementById("default_message") as HTMLElement;
    //     let url = appconfig.azure_reports_url+"/api/workinghrs";
    //     axios.get(url).then(response => {
    //        if(response.data.OffHourMessage != ""){
    //             // admin_message.style.display = "block";
    //             // default_message.style.display = "none";
    //             // admin_message.innerHTML = response.data.OffHourMessage;
    //        }else{
    //             if(admin_message != null)admin_message.style.display = "none";
    //             if(default_message != null)default_message.style.display = "";
    //        }
    //     })
    // }

    loadWorkingHoursMessage = () => {
        let admin_messageAR = document.getElementById("admin_message") as HTMLElement;
        let admin_messageEN = document.getElementById("admin_messageEN") as HTMLElement;
        //let default_message = document.getElementById("default_message") as HTMLElement;
        let url = appconfig.azure_reports_url + "/api/customer-meeting/isWorkingHours/gosi-public";
       // console.log(admin_messageAR)
        let lang = localStorage.getItem("lang");
        axios.get(url).then(response => {
            if (response.data.messge != "") {
                if (admin_messageAR && admin_messageEN ) {
                    console.log("we are inside the page  kiro")
                    //default_message.style.display = "none";
                    admin_messageEN.innerHTML = response.data.messge[0];
                     admin_messageAR.innerHTML = response.data.messge[1];
                     if(lang == "en"){
                         admin_messageEN.style.display = "";
                         admin_messageAR.style.display = "none";
                     }else{
                         admin_messageAR.style.display = "";
                         admin_messageEN.style.display = "none";
                     }
                }
                else{
                    console.log("we are not inside the page kiro")
                }
               
            } else {
                if (admin_messageAR && admin_messageEN) {
                    admin_messageAR.style.display = "none";
                    admin_messageEN.style.display = "none";
                    
                }
                else{
                    console.log("we are not inside the page kiro")
                }
            }
        })
    }
    render() {
        let endOfWorkingHours = "2";
        if (this.isPublic() == true) {
            return (
                <div id="main">
                    <div className='main-container' >
                        <div className='row'>
                        <div className='t2'>    <span className='t1' data-i18n="virtual_head">الزيارة الافتراضية</span></div>
                        </div>
                        <div className='row'>
                            <span className='p1 p2' data-i18n="service_virtual_visit">تتيح هذه الخدمة امكانية عقد زيارة افتراضية والتواصل مع موظف خدمة العملاء عبر الاتصال المرئى بكل سهولة ويسر</span>
                        </div>
                        <hr></hr>
                       
                        <div className='row'  >
                            <div className='col-md-12'  id="admin_message" style={{ display: "none" }}> </div>
                            <div className='col-md-12'  id="admin_messageEN" style={{ display: "none" }}> </div>
                        </div>
                        {/* <div className='row'  id="default_message">
                            <div className='col-md-12' style={{ textAlign: "right" }}>
                                <div className='paragraph' style={{ textAlign: "right" }} >
                                    <span data-i18n="unavaibility_message">
                                         عملائنا الأعزاء نعتذر منكم الخدمة غير متوفرة حاليا وتسعدنا خدمتكم خلال أوقات العمل
                                    </span>
                                    <dl>
                                        <li data-i18='date_avail1'>
                                            من الاحد الى الخميس بين الساعة 08:00 صباحاً الى الساعة 06:00 مساءً
                                        </li>

                                        <li data-i18='date_avail2'>
                                            الجمعة بين الساعة 02:00 مساءً الى الساعة 06:00 مساءً
                                        </li>

                                        <li data-i18="date_avail3">
                                            السبت بين الساعة 09:00 صباحاً الى الساعة 02:00 مساءً
                                        </li>
                                    </dl>

                                </div>
                            </div>
                        </div> */}



                    </div>
                </div>
            )
        }
        else {
            return (
                <div id="main">
                    <div className='private-container'>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 data-i18n="virtual_head">
                                    خدمة الزيارة الافتراضية
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-headset" viewBox="0 0 16 16">
                                            <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"></path>
                                        </svg>
                                    </span>

                                </h2>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-12" style={{ textAlign: "right" }} data-i18n="message">

                                تتيح هذه الخدمة إمكانية عقد زيارة افتراضية والتواصل مع موظف خدمة العملاء عبر الاتصال المرئي لتنفيذ المطلوب بكل سهولة ويسر

                            </div>
                        </div>
                        <hr></hr>
                        <div className='row'>
                            <div className='col-md-12' style={{ textAlign: "right" }}>
                                <div className='paragraph' style={{ textAlign: "right" }}>

                                    <dl>
                                        <li data-i18='date_avail1'>
                                            من الأحد الى الخميس من الساعة 8 صباحا حتى{endOfWorkingHours} مساءً
                                        </li>



                                        <li data-i18="date_avail3">
                                            السبت من الساعة 9 صباحا حتى 2 مساءً
                                        </li>
                                        <li data-i18='date_avail2'>
                                            الجمعة من الساعة 2 مساءً حتى 6 مساءً

                                        </li>
                                    </dl>
                                   {/*  كما يمكنكم حجز موعد للتواصل مع موظف خدمة العملاء من خلال خدمة <a href="" onClick={this.openCallMe}>اتصل بى </a>
                                    <br />
                                    ولارسال استفساراتكم واقتراحاتكم نأمل منكم التواصل معنا من خلال <a href="" onClick={this.openContactUs}>تواصل معنا</a> */}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )
        } //else
    }
}

export default AfterWorkingHours;
